/*
 *
 * AdminAssessmentTool actions
 *
 */

import { createAction } from 'redux-actions';
import {
  PROCESSING,
  GET_ADMIN_ASSESSMENTS,
  GET_ADMIN_ASSESSMENTS_RESULT,
  GET_FULL_ADMIN_ASSESSMENTS,
  GET_FULL_ADMIN_ASSESSMENTS_RESULT,
  SUBMIT_ADMIN_ASSESSMENT,
  SUBMIT_ADMIN_ASSESSMENT_RESULT,
} from './constants';

export const processing = createAction(PROCESSING);
export const getAdminAssessments = createAction(GET_ADMIN_ASSESSMENTS);
export const getAdminAssessmentsResult = createAction(
  GET_ADMIN_ASSESSMENTS_RESULT,
);
export const getFullAdminAssessments = createAction(GET_FULL_ADMIN_ASSESSMENTS);
export const getFullAdminAssessmentsResult = createAction(
  GET_FULL_ADMIN_ASSESSMENTS_RESULT,
);
export const submitAdminAssessment = createAction(SUBMIT_ADMIN_ASSESSMENT);
export const submitAdminAssessmentResult = createAction(
  SUBMIT_ADMIN_ASSESSMENT_RESULT,
);
